/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import ZoneControl from 'solis/logic/board/zone/control';
import ZoneInfluences from 'solis/logic/board/zone/influences';
import ZoneUsers from 'solis/logic/board/zone/users';

import TimelineEvent from 'solis/logic/board/zone/timeline/event';


export default class SurrenderEvent extends TimelineEvent
{
  constructor (zone, date)
  {
    super(zone);

    this.date = date;
  }


  apply ()
  {
    super.apply();

    const influences = new ZoneInfluences(this.zone);

    influences.destroyUserInfluences(new ZoneUsers(this.zone).getCurrentUser());
    influences.establishEnemyInfluences();

    new ZoneControl(this.zone).updateUser();
  }


};
